import SelectDefaultErrorPage from './SelectDefaultErrorPage'

export default SelectDefaultErrorPage
